import { render } from "./ServicesExpanded.vue?vue&type=template&id=721b88d4&scoped=true"
import script from "./ServicesExpanded.vue?vue&type=script&lang=js"
export * from "./ServicesExpanded.vue?vue&type=script&lang=js"

import "./ServicesExpanded.vue?vue&type=style&index=0&id=721b88d4&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721b88d4"]])

export default __exports__